import { AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import desktopImage from '../../../assets/images/backoffice/travelPackages/travelPackages.png';
import mobileImage from '../../../assets/images/backoffice/travelPackages/travelPackagesMobile.png';
import { AnimatedDashboard } from '../../../components/animation/AnimatedDashboard';
import { AnimatedTab } from '../../../components/animation/AnimatedTab';
import { CheckText } from '../../../components/common/CheckText';
import { Hub } from '../../../components/common/Hub/Hub';
import Spinner from '../../../components/common/Spinner';
import { getUserTickets } from '../../../slices/auth-slice';
import { H3, P1, P2 } from '../../../styles/FontStyles';
import { Button, Flexed, PageTitle } from '../../../styles/GlobalComponents';
import { color, lightTheme } from '../../../styles/GlobalStyles';
import { Desktop, Mobile } from '../../Kyc/KycStyled';
import {
  getTravelPackages,
  getTravelutionSubscriptions
} from '../Marketplace.actions';
import { StakingHubDetailsStyled } from '../Marketplace.styled';
import { PurchasePackageAndCombo } from '../PurchasePackageAndCombo/PurchasePackageAndCombo';

export const TravelPackages = () => {
  const dispatch = useDispatch();

  const { loading, hubs, subscriptions } = useSelector(
    (state) => state.marketplace
  );

  useEffect(() => {
    dispatch(getTravelPackages());
    dispatch(getUserTickets());
    dispatch(getTravelutionSubscriptions());
  }, [dispatch]);

  const [selectedHub, setSelectedHub] = useState(hubs?.[0] || null);
  const [modal, setModal] = useState(false);

  const handleSeeDetails = (hub) => {
    setSelectedHub(hub);
  };

  const handleSelectPackage = (hub) => {
    setModal(true);
    handleSeeDetails(hub);
  };

  useEffect(() => {
    setSelectedHub(hubs?.[0]);
  }, [hubs]);

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'marketplace'}>
      <Desktop>
        <section style={{ position: 'relative' }}>
          <img src={desktopImage} alt='trading' style={{ width: '100%' }} />
          {/* <CountdownComponent timestamp={timestamp} /> */}
        </section>
      </Desktop>

      <Mobile>
        <section style={{ position: 'relative' }}>
          <img src={mobileImage} alt='trading' style={{ width: '100%' }} />
        </section>
      </Mobile>

      <P1 mb='20' mt='40'>
        Ready to join the industry that everyone loves?
      </P1>
      <P1 mb='20'>
        Be a part of the biggest business opportunity of our lifetime and join
        the $11 Trillion Industry with Travelution!
      </P1>
      <P1 mb='40'>
        Get your ticket by becoming a Travelution club member and enjoy the best
        deals on the planet while getting paid part of Travelution App revenue
        every year!
      </P1>

      <PageTitle>SPECIAL PROMOTION - Pre-Presale Membership Packages</PageTitle>
      <P2 color={lightTheme.colors.neutral500}>
        *You are eligible to receive the tickets for pools if you have a paid
        Back-office subscription.
      </P2>

      <Flexed mt='40' rowSM gap={selectedHub !== null ? '100px' : '0'}>
        <Flexed
          column
          width={selectedHub !== null ? '65%' : '100%'}
          widthSM='100%'
          style={{ transition: 'width 300ms ease' }}>
          {hubs?.map((hub) => {
            const { id, image, name, price, priceToShow, subtitle, tickets } =
              hub;

            return (
              <Hub
                id={id}
                key={id}
                image={image}
                showTickets={false}
                title={name}
                price={price}
                priceToShow={priceToShow}
                subtitle={subtitle}
                tickets={tickets}
                onClick={() => handleSeeDetails(hub)}
                selected={selectedHub?.id === id}
                button={
                  <Button
                    w='200px'
                    wSM='100%'
                    onClick={() => handleSelectPackage(hub)}
                    negative={selectedHub?.id !== id}>
                    Select Membership
                  </Button>
                }
                stakingHubDetails={<StakingHubDetails hub={hub} />}
              />
            );
          })}
        </Flexed>
        <Flexed
          desktop
          column
          width={selectedHub !== null ? '35%' : '0'}
          widthSM='100%'
          style={{ transition: 'width 300ms ease' }}>
          <div
            style={{
              position: 'sticky',
              top: 200
            }}>
            <AnimatePresence exitBeforeEnter>
              {selectedHub?.id &&
                hubs?.map((hub, i) => {
                  if (hub?.id === selectedHub?.id) {
                    return (
                      <AnimatedTab key={i}>
                        <H3 mb='4' color={color.colors.primary900}>
                          {hub?.name}
                        </H3>
                        <StakingHubDetailsStyled>
                          <StakingHubDetails hub={hub} />
                        </StakingHubDetailsStyled>
                      </AnimatedTab>
                    );
                  } else return null;
                })}
              {selectedHub?.id &&
                subscriptions?.map((hub, i) => {
                  if (hub?.id === selectedHub?.id) {
                    return (
                      <AnimatedTab key={i}>
                        <H3 mb='4' color={color.colors.primary900}>
                          {hub?.name}
                        </H3>
                        <StakingHubDetailsStyled>
                          <StakingHubDetails hub={hub} />
                        </StakingHubDetailsStyled>
                      </AnimatedTab>
                    );
                  } else return null;
                })}
            </AnimatePresence>
          </div>
        </Flexed>
      </Flexed>

      <Flexed rowSM gap={selectedHub !== null ? '100px' : '0'}>
        <Flexed
          column
          width={selectedHub !== null ? '65%' : '100%'}
          widthSM='100%'
          style={{ transition: 'width 300ms ease' }}>
          {subscriptions?.map((hub) => {
            const { id, image, name, price, priceToShow, subtitle, tickets } =
              hub;
            return (
              <Hub
                id={id}
                key={id}
                image={image}
                showTickets={false}
                title={name}
                price={price}
                priceToShow={priceToShow}
                subtitle={subtitle}
                tickets={tickets}
                onClick={() => handleSeeDetails(hub)}
                selected={selectedHub?.id === id}
                button={
                  <Button
                    w='200px'
                    wSM='100%'
                    onClick={() => handleSelectPackage(hub)}
                    negative={selectedHub?.id !== id}>
                    Select Membership
                  </Button>
                }
                stakingHubDetails={<StakingHubDetails hub={hub} />}
              />
            );
          })}
        </Flexed>
        <Flexed
          desktop
          column
          width={selectedHub !== null ? '35%' : '0'}
          widthSM='100%'
          style={{ transition: 'width 300ms ease' }}>
          <div
            style={{
              position: 'sticky',
              top: 200
            }}>
            <AnimatePresence exitBeforeEnter></AnimatePresence>
          </div>
        </Flexed>
      </Flexed>

      <PurchasePackageAndCombo
        selectedPackage={selectedHub}
        modal={modal}
        setModal={setModal}
      />
    </AnimatedDashboard>
  );
};

const StakingHubDetails = ({ hub }) => {
  return (
    <div>
      <P1 semiBold color={color.colors.neutral500} mb='12'>
        Membership Benefits
      </P1>
      {hub?.whaleBenefits?.map((benefit, i) => (
        <div key={i}>
          <CheckText text={benefit} />
        </div>
      ))}
    </div>
  );
};
